(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_971f53b"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiyomasa-wrapping-add')) {
customElements.define(
'kiyomasa-wrapping-add',
class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;

const input = this.querySelector('.wrap-input');
const minus = this.querySelector('[data-quantity-minus]');
const plus = this.querySelector('[data-quantity-plus]');

if (!input || !minus || !plus) return;
this.initialized = true;

const min = Number(input.min) || 1;
const step = Number(input.step) || 1;
const max = input.hasAttribute('max')
? Number(input.max)
: Infinity;

const syncButtons = () => {
const value = Number(input.value);
minus.disabled = input.disabled || value - step < min;
plus.disabled = input.disabled || value + step > max;
};

const normalize = () => {
if (input.disabled) return;

let value = Number(input.value);
if (!Number.isFinite(value)) value = min;

value = Math.max(min, Math.min(max, value));
value = min + Math.floor((value - min) / step) * step;
input.value = String(value);
syncButtons();
};

const changeQuantity = (direction) => {
if (input.disabled) return;

normalize();

const next = Number(input.value) + direction * step;
if (next < min || next > max) return;

input.value = String(next);
input.dispatchEvent(new Event('input', { bubbles: true }));
input.dispatchEvent(new Event('change', { bubbles: true }));
};

minus.addEventListener('click', () => changeQuantity(-1));
plus.addEventListener('click', () => changeQuantity(1));
input.addEventListener('input', syncButtons);
input.addEventListener('change', normalize);

syncButtons();
}
}
);
}
  } catch(e) { console.error(e); }
})();

})();
